import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";

const navLinks = [
  { to: "/", label: "首页" },
  { to: "/characters", label: "角色专区" },
  { to: "/works", label: "同人作品" },
  { to: "/about", label: "关于我们" },
  { to: "/faq", label: "常见问题" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  return (
    <header className="sticky top-0 z-50 w-full">
      <nav
        className={`w-full transition-colors duration-300 ${
          scrolled || open
            ? "bg-background-50/95 backdrop-blur border-b border-background-200"
            : "bg-transparent"
        }`}
      >
        <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 md:px-6">
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap" aria-label="火影同人志 首页">
            <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500">
              <i className="ri-leaf-fill text-lg text-background-50" aria-hidden="true"></i>
            </span>
            <span className="font-heading text-lg font-bold text-foreground-950">
              火影<span className="text-primary-600">同人志</span>
            </span>
          </Link>

          <div className="hidden items-center gap-1 md:flex">
            {navLinks.map((link) => (
              <NavLink
                key={link.to}
                to={link.to}
                className={({ isActive }) =>
                  `rounded-md px-4 py-2 text-sm font-medium transition-colors whitespace-nowrap ${
                    isActive
                      ? "bg-primary-500 text-background-50"
                      : "text-foreground-700 hover:bg-background-100 hover:text-foreground-950"
                  }`
                }
              >
                {link.label}
              </NavLink>
            ))}
          </div>

          <div className="hidden items-center gap-3 md:flex">
            <Link
              to="/works"
              className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-secondary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-secondary-600"
            >
              <i className="ri-book-open-line text-sm" aria-hidden="true"></i>
              开始阅读
            </Link>
          </div>

          <button
            type="button"
            onClick={() => setOpen((v) => !v)}
            className="flex h-10 w-10 items-center justify-center rounded-md text-foreground-800 hover:bg-background-100 md:hidden"
            aria-label={open ? "关闭菜单" : "打开菜单"}
            aria-expanded={open}
          >
            <i className={open ? "ri-close-line text-2xl" : "ri-menu-line text-2xl"} aria-hidden="true"></i>
          </button>
        </div>

        {open && (
          <div className="border-t border-background-200 bg-background-50 px-4 pb-4 pt-2 md:hidden">
            <div className="flex flex-col gap-1">
              {navLinks.map((link) => (
                <NavLink
                  key={link.to}
                  to={link.to}
                  className={({ isActive }) =>
                    `rounded-md px-4 py-3 text-sm font-medium ${
                      isActive
                        ? "bg-primary-500 text-background-50"
                        : "text-foreground-800 hover:bg-background-100"
                    }`
                  }
                >
                  {link.label}
                </NavLink>
              ))}
              <Link
                to="/works"
                className="mt-2 inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-secondary-500 px-4 py-3 text-sm font-medium text-background-50"
              >
                <i className="ri-book-open-line text-sm" aria-hidden="true"></i>
                开始阅读
              </Link>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
}